import React, { useEffect, useState } from "react";
import { AppBar, Box, Tab, Tabs, Tooltip, Typography } from '@material-ui/core/';
import { Alert } from "@material-ui/lab";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ChildrenLoading from "../../../components/ChildrenLoading";

import RepLIChart from "./RepLIChart.component";
import RepLIProfile from "./RepLIProfile.component";

import useStyles from "./RepLI.style";
import Cookies from 'universal-cookie';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from "@mui/material";

const cookies = new Cookies();

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`repli-tabpanel-${index}`}
            aria-labelledby={`repli-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>
                    {children}
                </>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `repli-tab-${index}`,
        'aria-controls': `repli-tabpanel-${index}`,
    };
}

const RepLI = () => {
    const classes = useStyles();
    const { patientId } = useParams();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [tabIndex, setTabIndex] = useState(0);
    const [healthProfile, setHealthProfile] = useState();


    useEffect(() => {
        const getHealthProfile = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_PATIENT_PROFILE}/${patientId}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (!response) return;
                let profile = await response.json();
                if (!profile.dateOfBirth) {
                    setError(t('module.provider.repli.profile.message.profileNotFound'));
                    return;
                }
                setHealthProfile(profile);
            } catch (error) {
                console.log(error);
                setError(t('module.provider.repli.profile.message.fetchDataFailure'));
            } finally {
                setLoading(false);
            }
        };

        getHealthProfile();
    }, [patientId, t]);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const handleBackClicked = () => {
        window.history.back();
    };


    if (loading) return <ChildrenLoading />
    if (error) return <Alert className={classes.root} severity="error">{error}</Alert>

    return (
        <Box className={classes.root}>
            <Tooltip arrow title="Back">
                <IconButton
                    aria-label="Back"
                    color="primary"
                    component={Link}
                    to={`/provider/patient/profile/${patientId}`}
                >
                    <ArrowBackIcon />
                </IconButton>
            </Tooltip>
            <Typography variant="h4" className={classes.title}>
                {healthProfile.firstName} {healthProfile.lastName}'s  RepLI
            </Typography>
            {/* <AppBar position="static" color="default" className={classes.tab} elevation={0}>
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label={t('module.provider.repli.tab.chart')} {...a11yProps(0)} />
                    <Tab label={t('module.provider.repli.tab.profile')} {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <TabPanel value={tabIndex} index={0}>
                <RepLIChart profile={healthProfile} />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
                <RepLIProfile profile={healthProfile} />
            </TabPanel> */}

            <AppBar position="static" color="default" className={classes.tab} elevation={0}>
                <RepLIChart profile={healthProfile} />
            </AppBar>
        </Box>
    )
};

export default RepLI;
